export default __webpack_public_path__ + "static/media/narx.e874aa05.svg";